/* mySHOPPY theme scripts */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-menu-btn]');
    var openDropdowns = document.querySelectorAll('[data-menu-dropdown].open');
    if (btn) {
      e.stopPropagation();
      var dd = btn.parentNode.querySelector('[data-menu-dropdown]');
      if (dd) {
        var isOpen = dd.classList.toggle('open');
        btn.setAttribute('aria-expanded', isOpen);
      }
      return;
    }
    openDropdowns.forEach(function (dd) {
      if (!dd.contains(e.target)) {
        dd.classList.remove('open');
        var b = dd.parentNode.querySelector('[data-menu-btn]');
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    });
  });
})();
